import * as React from "react";
const SvgCharger20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M16 3h3v8a6 6 0 0 1-6 6h-2v3H9v-3H7a6 6 0 0 1-6-6V3h3V0h2v3h8V0h2v3ZM3 5v6a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4V5H3Zm3 6 5-5-1 3h4l-5 5 1-3H6Z",
      clipRule: "evenodd"
    })
  );
export default SvgCharger20Px;
